export enum QUERY_KEYS {
  TOOL = 'TOOL',
  TOOLS = 'TOOLS',
}

export default QUERY_KEYS
